var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"collapsible":"","collapsed":"","info-mode":"","help-collapsed":_vm.sectionHelp,"help":_vm.sectionHelp,"title":_vm.sectionTitle}},[_c('kst-number-with-date',{attrs:{"view-mode":"","catalog":_vm.Catalog,"data":_vm.deliveryData,"dateField":"SalesOrderDate","numberField":"SOID"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }